<template>

  <li>
    <a class="user-profile dropdown-toggle">
      <img 
        :src="user.photoUrl"
        alt="" 
      >
      {{ user.first }} {{ user.last }}
      <span class=" fa fa-angle-down"></span>
    </a>
    <ul class="dropdown-menu dropdown-usermenu pull-right">
      <li><a v-on:click="logout()"><i class="fa fa-sign-out pull-right"></i> Log Out</a></li>
    </ul>
  </li>

</template>

<script>
import md5 from 'md5'
export default {
  name: 'UserPanel',
  data () {
    return {
      user: {
        email: '',
        photoUrl: ''
      }
    }
  },
  mounted () {
    this.setUserPhoto()
  },
  methods: {
    setUserPhoto () {
      let hash = ''
      if (typeof this.user.email !== undefined && this.user.email !== '') {
        hash = md5(this.user.email)
      }
      console.log(hash)
      let url = 'https://www.gravatar.com/avatar/' + hash + '?d=mm'
      this.$set(this.user, 'photoUrl', url)
    },
    logout () {
      this.$user().logout().then((response) => {
        this.$router.push('/login')
      })
    }
  }
}
</script>

<style>
.navbar-nav li:hover .dropdown-menu {
  position: absolute;
  display: block;
  background: #fff;
  margin-top: 0;
  border: 1px solid #D9DEE4;
  -webkit-box-shadow: none;
  right: 0;
  left: auto;
  width: 220px;
}
</style>



// WEBPACK FOOTER //
// UserPanel.vue?29b0a5c4